export default __webpack_public_path__ + "static/media/N_Nariz.8cff904a.mp3";